// extracted by mini-css-extract-plugin
export var coloredText = "styles-mod--colored-text--6d5c4";
export var email = "styles-mod--email--7de41";
export var emailButtonContainer = "styles-mod--email-button-container--7c024";
export var errorMessage = "styles-mod--error-message--4f389";
export var formContainer = "styles-mod--form-container--d8510";
export var linkSignUp = "styles-mod--link-sign-up--d83f2";
export var privateSaleContainer = "styles-mod--private-sale-container--60ec2";
export var privateSaleCountdown = "styles-mod--private-sale-countdown--2e816";
export var submitButton = "styles-mod--submit-button--491bb";